const publicFontPath = 'https://d1tntvpcrzvon2.cloudfront.net/static-assets/fonts/';
const sidebarWidth = 195;
const buttonBoxShadow = '0 0 8px 0 rgba(0, 59, 88, 0.1)';

// These values come from @zola/zola-ui/src/styles/common/_variables.less
const colorEmperor = '#505050';
const colorBoulder = '#767676';
const colorBlueLagoon = '#005883';
const colorNavy = '#003b58';
const colorNavyDarker = '#01202f';

// To customize Uploadcare's 3rd party iframe tabs (e.g. Facebook, Google Photos, etc.),
// we can either pass the widget a string or a URL of a stylesheet served over HTTPS.
// We chose a string to avoid having to build and serve the stylesheet separately.
// All changes must also be made to corresponding classes from styles.module.less
const thirdPartyTabStyles = `

font-family: 'proxima-nova';
font-weight: 300;
src: url('${publicFontPath}ProximaNova-Light.otf'),
    url('${publicFontPath}ProximaNova-Light.eot') format('embedded-opentype'),
    url('${publicFontPath}ProximaNova-Light.woff2') format('woff2'),
    url('${publicFontPath}ProximaNova-Light.woff') format('woff'),
    url('${publicFontPath}ProximaNova-Light.ttf') format('truetype');
}

@font-face {
font-family: 'proxima-nova';
font-weight: 300;
font-style: italic;
src: url('${publicFontPath}ProximaNova-LightItalic.otf'),
    url('${publicFontPath}ProximaNova-LightItalic.eot') format('embedded-opentype'),
    url('${publicFontPath}ProximaNova-LightItalic.woff2') format('woff2'),
    url('${publicFontPath}ProximaNova-LightItalic.woff') format('woff'),
    url('${publicFontPath}ProximaNova-LightItalic.ttf') format('truetype');
}

@font-face {
font-family: 'proxima-nova';
font-weight: 400;
src: url('${publicFontPath}ProximaNova-Regular.otf'),
    url('${publicFontPath}ProximaNova-Regular.eot') format('embedded-opentype'),
    url('${publicFontPath}ProximaNova-Regular.woff2') format('woff2'),
    url('${publicFontPath}ProximaNova-Regular.woff') format('woff'),
    url('${publicFontPath}ProximaNova-Regular.ttf') format('truetype');
}

@font-face {
font-family: 'proxima-nova';
font-weight: 400;
font-style: italic;
src: url('${publicFontPath}ProximaNova-RegularItalic.otf'),
    url('${publicFontPath}ProximaNova-RegularItalic.eot') format('embedded-opentype'),
    url('${publicFontPath}ProximaNova-RegularItalic.woff2') format('woff2'),
    url('${publicFontPath}ProximaNova-RegularItalic.woff') format('woff'),
    url('${publicFontPath}ProximaNova-RegularItalic.ttf') format('truetype');
}

@font-face {
font-family: 'proxima-nova';
font-weight: 600;
src: url('${publicFontPath}ProximaNova-Semibold.otf'),
    url('${publicFontPath}ProximaNova-Semibold.eot') format('embedded-opentype'),
    url('${publicFontPath}ProximaNova-Semibold.woff2') format('woff2'),
    url('${publicFontPath}ProximaNova-Semibold.woff') format('woff'),
    url('${publicFontPath}ProximaNova-Semibold.ttf') format('truetype');
}

@font-face {
font-family: 'proxima-nova';
font-weight: 600;
font-style: italic;
src: url('${publicFontPath}ProximaNova-SemiboldItalic.otf'),
    url('${publicFontPath}ProximaNova-SemiboldItalic.eot') format('embedded-opentype'),
    url('${publicFontPath}ProximaNova-SemiboldItalic.woff2') format('woff2'),
    url('${publicFontPath}ProximaNova-SemiboldItalic.woff') format('woff'),
    url('${publicFontPath}ProximaNova-SemiboldItalic.ttf') format('truetype');
}

@font-face {
font-family: 'proxima-nova';
font-weight: 700;
src: url('${publicFontPath}ProximaNova-Bold.otf'),
    url('${publicFontPath}ProximaNova-Bold.eot') format('embedded-opentype'),
    url('${publicFontPath}ProximaNova-Bold.woff2') format('woff2'),
    url('${publicFontPath}ProximaNova-Bold.woff') format('woff'),
    url('${publicFontPath}ProximaNova-Bold.ttf') format('truetype');
}

@font-face {
font-family: 'proxima-nova';
font-weight: 700;
font-style: italic;
src: url('${publicFontPath}ProximaNova-BoldIt.otf'),
    url('${publicFontPath}ProximaNova-BoldIt.eot') format('embedded-opentype'),
    url('${publicFontPath}ProximaNova-BoldIt.woff2') format('woff2'),
    url('${publicFontPath}ProximaNova-BoldIt.woff') format('woff'),
    url('${publicFontPath}ProximaNova-BoldIt.ttf') format('truetype');
}

@font-face {
font-family: 'proxima-nova';
font-weight: 800;
src: url('${publicFontPath}ProximaNova-Extrabold.otf'),
    url('${publicFontPath}ProximaNova-Extrabold.eot') format('embedded-opentype'),
    url('${publicFontPath}ProximaNova-Extrabold.woff2') format('woff2'),
    url('${publicFontPath}ProximaNova-Extrabold.woff') format('woff'),
    url('${publicFontPath}ProximaNova-Extrabold.ttf') format('truetype');
}

@font-face {
font-family: 'proxima-nova';
font-weight: 900;
src: url('${publicFontPath}ProximaNova-Black.otf'),
    url('${publicFontPath}ProximaNova-Black.eot') format('embedded-opentype'),
    url('${publicFontPath}ProximaNova-Black.woff2') format('woff2'),
    url('${publicFontPath}ProximaNova-Black.woff') format('woff'),
    url('${publicFontPath}ProximaNova-Black.ttf') format('truetype');
}

body {
  font-family: "proxima-nova", "Helvetica", Arial, sans-serif;
  color: #21201F;
  background-image: url('${publicFontPath}ProximaNova-Light.otf');
}

/* (1st party) .uploadcare--text_size_extra-large */
.welcome h1 {
  font-size: 24px;
  line-height: 36px;
  font-weight: 500;
  margin: 0;
}

/* (1st party) .uploadcare--text_muted */
.welcome h2 {
  color: ${colorEmperor};
  font-size: 16px;
  line-height: 24px;
}

/* (1st party) .uploadcare--button_primary */
.welcome .big-button {
  cursor: pointer;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 500;
  line-height: 1;
  padding: 13px 16px;
  text-transform: capitalize;
  box-shadow: ${buttonBoxShadow};
  background: ${colorNavy};
  border: 1px solid transparent;
}
.welcome .big-button:hover {
  box-shadow: ${buttonBoxShadow};
  background: ${colorBlueLagoon};
  border-color: transparent;
}
.welcome .big-button:focus {
  outline: 5px auto -webkit-focus-ring-color;
  outline-offset: 0;
  box-shadow: ${buttonBoxShadow};
  background: ${colorBlueLagoon};
  border-color: transparent;
}
.welcome .big-button:active {
  background: ${colorNavyDarker};
  border-color: transparent;
}
.welcome .big-button .big-button__icon {
  display: none;
}

.welcome .muted {
  color: ${colorBoulder};
  font-size: 12px;
  line-height: 16px;
}

/* ---------- UPLOAD SECTION ---------- */
.side-bar {
  background: #F8F8F8;
}
@media (min-width: 601px) {
  .side-bar {
    width: ${sidebarWidth}px;
    box-sizing: border-box;
  }
  .main-content,
  .main-content-header {
    margin-left: ${sidebarWidth}px;
    padding-left: 20px;
  }
}

.side-bar h3 {
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
}

.logout-link {
  font-size: 12px;
  line-height: 16px;
}

.side-bar-menu .menu-item {
  padding: 6px 0;
}

.side-bar-menu a {
  font-weight: 600;
  font-size: 16px;
  line-height: 1;
  color: #0075ae;
}
.side-bar-menu a:hover {
  color: #005883;
}
.side-bar-menu a:after {
  content: ' →';
  display: inline;
  vertical-align: middle;
}

.bread-crumbs a {
  color: ${colorBoulder};
  font-size: 12px;
  line-height: 16px;
}
.bread-crumbs li:after {
  content: '›';
  color: ${colorEmperor};
  font-size: 18px;
  line-height: 1;
  background: none;
  margin-top: 0;
  margin-left: 10px;
  height: auto;
  width: auto;
  vertical-align: middle;
}
.main-content-header h2 {
  font-size: 14px;
  font-weight: 600;
}
.list-table-header {
  text-transform: capitalize;
  font-size: 12px;
  line-height: 16px;
}
.list-table-header .list-table-cell-a,
.list-table-header .list-table-cell-b {
  padding: 16px 0 4px 0;
}

.uploadcare--panel__file-counter {
  display: none;
}
`;

export default thirdPartyTabStyles;
